import ConfirmDialog from "./ConfirmDialog";

export default class SuccessDialog extends ConfirmDialog {
    constructor(text) {
        super(text);
        this.label && this.label.destroy();

        let label = new PIXI.Text(this._text, {
            fontSize: 36,
            fontFamily: "Fred Fredburger",
            align: 'center',
            colour: 0x07485B,
            wordWrap: true,
            wordWrapWidth: 420
        });
        //  label.maxWidth = 420;
        label.anchor.set(0.5);
        label.position.x += 60;
        this.label = label;
        //this.addChild(label);

        this._approveButton.destroy();
        this._cancelButton.destroy();
    }
}